var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "table" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c("div", [
          _c("p", {
            staticClass: "icon-jujue closeBtn",
            on: { click: _vm.routerBack },
          }),
        ]),
        _vm.isMy
          ? _c(
              "div",
              { staticClass: "handle-box" },
              [
                _c(
                  "el-row",
                  { attrs: { type: "flex", align: "middle" } },
                  [
                    _vm.detailInfo.status == "DRAFT"
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "acl",
                                rawName: "v-acl",
                                value: _vm.RMC_PROT_MEDICINE_SAVE,
                                expression: "RMC_PROT_MEDICINE_SAVE",
                              },
                            ],
                            attrs: { size: "mini", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.saveData("detailInfo")
                              },
                            },
                          },
                          [_vm._v("保存")]
                        )
                      : _vm._e(),
                    _vm.detailInfo.status == "DRAFT" ||
                    _vm.detailInfo.status == "PASS" ||
                    (_vm.detailInfo.status == "BACK" && _vm.statusView == "S")
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "acl",
                                rawName: "v-acl",
                                value: _vm.RMC_PROT_MEDICINE_SUBMIT,
                                expression: "RMC_PROT_MEDICINE_SUBMIT",
                              },
                            ],
                            attrs: { size: "mini", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.submitData("detailInfo")
                              },
                            },
                          },
                          [_vm._v("提交")]
                        )
                      : _vm._e(),
                    !_vm.statusVal
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "acl",
                                rawName: "v-acl",
                                value: _vm.RMC_PROT_MEDICINE_APPROVE,
                                expression: "RMC_PROT_MEDICINE_APPROVE",
                              },
                            ],
                            attrs: { size: "mini", type: "primary" },
                            on: { click: _vm.approve },
                          },
                          [_vm._v("批准")]
                        )
                      : _vm._e(),
                    !_vm.statusVal
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "acl",
                                rawName: "v-acl",
                                value: _vm.RMC_PROT_MEDICINE_RETURN,
                                expression: "RMC_PROT_MEDICINE_RETURN",
                              },
                            ],
                            attrs: { size: "mini", type: "primary" },
                            on: { click: _vm.sendBack },
                          },
                          [_vm._v("退回")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          {
            staticClass: "handle-box",
            staticStyle: { "padding-bottom": "10px" },
          },
          [
            _vm._m(0),
            _c(
              "el-form",
              {
                ref: "detailInfo",
                staticClass: "searchForm",
                attrs: {
                  model: _vm.detailInfo,
                  rules: _vm.rules,
                  "label-position": "right",
                  "label-width": "120px",
                },
              },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "Category3",
                              prop: "category3Code",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled:
                                    _vm.category3List.length > 1 &&
                                    _vm.isDisabled &&
                                    _vm.isSet
                                      ? false
                                      : true,
                                  clearable: "",
                                  placeholder: "请选择",
                                },
                                on: { change: _vm.getCategory3Name },
                                model: {
                                  value: _vm.detailInfo.category3Code,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.detailInfo,
                                      "category3Code",
                                      $$v
                                    )
                                  },
                                  expression: "detailInfo.category3Code",
                                },
                              },
                              _vm._l(_vm.category3List, function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: item.object,
                                    value: item.key,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "Sponsor" } },
                          [
                            _c("el-input", {
                              attrs: {
                                disabled: "",
                                placeholder: "从供应商集团选择",
                              },
                              model: {
                                value: _vm.detailInfo.sponsorName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.detailInfo, "sponsorName", $$v)
                                },
                                expression: "detailInfo.sponsorName",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "ASL Group", prop: "aslGroupCode" },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled:
                                    _vm.isDisabled && _vm.isSet ? false : true,
                                  clearable: "",
                                  placeholder: "请选择",
                                },
                                on: { change: _vm.getAslName },
                                model: {
                                  value: _vm.detailInfo.aslGroupCode,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.detailInfo,
                                      "aslGroupCode",
                                      $$v
                                    )
                                  },
                                  expression: "detailInfo.aslGroupCode",
                                },
                              },
                              _vm._l(
                                _vm.aslGroupCodeList,
                                function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.aslGroupName,
                                      value: item.aslGroupCode,
                                      disabled: !item.enabled,
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "状态" } },
                          [
                            _c("ic-select", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                table: "TT_RMC_PROTEIN_MEDICINE",
                                disabled: "",
                                filterable: "",
                                field: "STATUS",
                                clearable: "",
                              },
                              model: {
                                value: _vm.detailInfo.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.detailInfo, "status", $$v)
                                },
                                expression: "detailInfo.status",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "有效成分",
                              prop: "effectiveComponents",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  filterable: "",
                                  disabled:
                                    _vm.isDisabled && _vm.isSet ? false : true,
                                  clearable: "",
                                  placeholder: "请选择",
                                },
                                on: { change: _vm.getOther },
                                model: {
                                  value: _vm.detailInfo.effectiveComponents,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.detailInfo,
                                      "effectiveComponents",
                                      $$v
                                    )
                                  },
                                  expression: "detailInfo.effectiveComponents",
                                },
                              },
                              _vm._l(
                                _vm.effectiveComponentsList,
                                function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.name,
                                      value: item.code,
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.isOther
                      ? _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "有效成分其他",
                                  prop: "effectiveComponentsOther",
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    disabled:
                                      _vm.isDisabled && _vm.isSet
                                        ? false
                                        : true,
                                    placeholder: "请输入内容",
                                  },
                                  model: {
                                    value:
                                      _vm.detailInfo.effectiveComponentsOther,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailInfo,
                                        "effectiveComponentsOther",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "detailInfo.effectiveComponentsOther",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "药品一级分类",
                              prop: "medicineLevelOneGrade",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled:
                                    _vm.isOther && _vm.isDisabled && _vm.isSet
                                      ? false
                                      : true,
                                  clearable: "",
                                  placeholder: "请选择",
                                },
                                model: {
                                  value: _vm.detailInfo.medicineLevelOneGrade,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.detailInfo,
                                      "medicineLevelOneGrade",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "detailInfo.medicineLevelOneGrade",
                                },
                              },
                              _vm._l(
                                _vm.medicineLevelOneGradeList,
                                function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.name,
                                      value: item.code,
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: _vm.isOther ? 6 : 12 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "药品二级分类",
                              prop: "medicineLevelTwoGrade",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled:
                                    _vm.isOther && _vm.isDisabled && _vm.isSet
                                      ? false
                                      : true,
                                  clearable: "",
                                  placeholder: "请选择",
                                },
                                model: {
                                  value: _vm.detailInfo.medicineLevelTwoGrade,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.detailInfo,
                                      "medicineLevelTwoGrade",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "detailInfo.medicineLevelTwoGrade",
                                },
                              },
                              _vm._l(
                                _vm.medicineLevelTwoGradeList,
                                function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.name,
                                      value: item.code,
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "WHO药品等级",
                              prop: "whoMedicineGrade",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled:
                                    _vm.isOther && _vm.isDisabled && _vm.isSet
                                      ? false
                                      : true,
                                  clearable: "",
                                  placeholder: "请选择",
                                },
                                model: {
                                  value: _vm.detailInfo.whoMedicineGrade,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.detailInfo,
                                      "whoMedicineGrade",
                                      $$v
                                    )
                                  },
                                  expression: "detailInfo.whoMedicineGrade",
                                },
                              },
                              _vm._l(
                                _vm.whoMedicineGradeList,
                                function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.name,
                                      value: item.code,
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "OIE药物等级",
                              prop: "oieMedicineGrade",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled:
                                    _vm.isOther && _vm.isDisabled && _vm.isSet
                                      ? false
                                      : true,
                                  clearable: "",
                                  placeholder: "请选择",
                                },
                                model: {
                                  value: _vm.detailInfo.oieMedicineGrade,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.detailInfo,
                                      "oieMedicineGrade",
                                      $$v
                                    )
                                  },
                                  expression: "detailInfo.oieMedicineGrade",
                                },
                              },
                              _vm._l(
                                _vm.oieMedicineGradeList,
                                function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.name,
                                      value: item.code,
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "通用名", prop: "commonName" } },
                          [
                            _c("el-autocomplete", {
                              staticClass: "inline-input",
                              staticStyle: { width: "100%" },
                              attrs: {
                                maxlength: "100",
                                disabled:
                                  _vm.isDisabled && _vm.isSet ? false : true,
                                "fetch-suggestions": _vm.querySearch,
                                placeholder: "请输入内容",
                                "trigger-on-focus": false,
                              },
                              on: { select: _vm.handleSelect },
                              model: {
                                value: _vm.detailInfo.commonName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.detailInfo, "commonName", $$v)
                                },
                                expression: "detailInfo.commonName",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "商品名", prop: "productName" } },
                          [
                            _c("el-autocomplete", {
                              staticClass: "inline-input",
                              staticStyle: { width: "100%" },
                              attrs: {
                                maxlength: "100",
                                disabled:
                                  _vm.isDisabled && _vm.isSet ? false : true,
                                "fetch-suggestions": _vm.querySearch1,
                                placeholder: "请输入内容",
                                "trigger-on-focus": false,
                              },
                              on: { select: _vm.handleSelect1 },
                              model: {
                                value: _vm.detailInfo.productName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.detailInfo, "productName", $$v)
                                },
                                expression: "detailInfo.productName",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "兽药批准文号",
                              prop: "approvelNumber",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                maxlength: "100",
                                disabled:
                                  _vm.isDisabled && _vm.isSet ? false : true,
                                placeholder: "请输入内容",
                              },
                              model: {
                                value: _vm.detailInfo.approvelNumber,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.detailInfo,
                                    "approvelNumber",
                                    $$v
                                  )
                                },
                                expression: "detailInfo.approvelNumber",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "有效成分和含量",
                              prop: "effectiveComponentsContent",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                maxlength: "300",
                                disabled:
                                  _vm.isDisabled && _vm.isSet ? false : true,
                                placeholder: "请输入内容",
                              },
                              model: {
                                value:
                                  _vm.detailInfo.effectiveComponentsContent,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.detailInfo,
                                    "effectiveComponentsContent",
                                    $$v
                                  )
                                },
                                expression:
                                  "detailInfo.effectiveComponentsContent",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "适应症", prop: "indication" } },
                          [
                            _c("el-input", {
                              attrs: {
                                maxlength: "100",
                                disabled:
                                  _vm.isDisabled && _vm.isSet ? false : true,
                                placeholder: "请输入内容",
                              },
                              model: {
                                value: _vm.detailInfo.indication,
                                callback: function ($$v) {
                                  _vm.$set(_vm.detailInfo, "indication", $$v)
                                },
                                expression: "detailInfo.indication",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "生产厂家", prop: "producer" } },
                          [
                            _c("el-input", {
                              attrs: {
                                maxlength: "100",
                                disabled:
                                  _vm.isDisabled && _vm.isSet ? false : true,
                                placeholder: "请输入内容",
                              },
                              model: {
                                value: _vm.detailInfo.producer,
                                callback: function ($$v) {
                                  _vm.$set(_vm.detailInfo, "producer", $$v)
                                },
                                expression: "detailInfo.producer",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "规格", prop: "specification" } },
                          [
                            _c("el-input", {
                              attrs: {
                                maxlength: "100",
                                disabled:
                                  _vm.isDisabled && _vm.isSet ? false : true,
                                placeholder: "请输入内容",
                              },
                              model: {
                                value: _vm.detailInfo.specification,
                                callback: function ($$v) {
                                  _vm.$set(_vm.detailInfo, "specification", $$v)
                                },
                                expression: "detailInfo.specification",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "用法和用量", prop: "usage" } },
                          [
                            _c("el-input", {
                              attrs: {
                                maxlength: "300",
                                disabled:
                                  _vm.isDisabled && _vm.isSet ? false : true,
                                placeholder: "请输入内容",
                              },
                              model: {
                                value: _vm.detailInfo.usage,
                                callback: function ($$v) {
                                  _vm.$set(_vm.detailInfo, "usage", $$v)
                                },
                                expression: "detailInfo.usage",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "休药期(天)",
                              prop: "withdrawalDay",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                maxlength: "10",
                                disabled:
                                  _vm.isDisabled && _vm.isSet ? false : true,
                                placeholder: "请输入内容",
                              },
                              model: {
                                value: _vm.detailInfo.withdrawalDay,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.detailInfo,
                                    "withdrawalDay",
                                    _vm._n($$v)
                                  )
                                },
                                expression: "detailInfo.withdrawalDay",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "最新检测时间" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                disabled:
                                  _vm.isDisabled && _vm.isSet ? false : true,
                                format: "yyyy-MM-dd",
                                "value-format": "yyyy-MM-dd",
                                type: "date",
                                placeholder: "选择日期",
                              },
                              model: {
                                value: _vm.detailInfo.lastDetectionTime,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.detailInfo,
                                    "lastDetectionTime",
                                    $$v
                                  )
                                },
                                expression: "detailInfo.lastDetectionTime",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "药品在用状态",
                              prop: "medicineUseStatus",
                            },
                          },
                          [
                            _c("ic-select", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                table: "TT_RMC_PROTEIN_MEDICINE",
                                filterable: "",
                                field: "MEDICINE_USE_STATUS",
                                disabled:
                                  _vm.isDisabled && _vm.isSet ? false : true,
                                clearable: "",
                              },
                              model: {
                                value: _vm.detailInfo.medicineUseStatus,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.detailInfo,
                                    "medicineUseStatus",
                                    $$v
                                  )
                                },
                                expression: "detailInfo.medicineUseStatus",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.detailInfo.category3Code == "10101"
                      ? _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "养殖模式",
                                  prop: "breedingMode",
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      disabled:
                                        _vm.isDisabled && _vm.isSet
                                          ? false
                                          : true,
                                      clearable: "",
                                      placeholder: "请选择",
                                    },
                                    model: {
                                      value: _vm.detailInfo.breedingMode,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.detailInfo,
                                          "breedingMode",
                                          $$v
                                        )
                                      },
                                      expression: "detailInfo.breedingMode",
                                    },
                                  },
                                  _vm._l(
                                    _vm.breedingModeOptions,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.object,
                                          value: item.key,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _vm.$route.query.id
                      ? _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "上次修改原因",
                                  prop: "momentUpdateReason",
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    type: "textarea",
                                    maxlength: "1000",
                                    "show-word-limit": "",
                                    placeholder: "请输入内容",
                                    disabled: "",
                                  },
                                  model: {
                                    value: _vm.momentUpdateReason,
                                    callback: function ($$v) {
                                      _vm.momentUpdateReason = $$v
                                    },
                                    expression: "momentUpdateReason",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "修改原因", prop: "modifyReason" },
                          },
                          [
                            _vm.detailInfo.modifyReason &&
                            _vm.detailInfo.modifyReason.length > 400
                              ? _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      effect: "dark",
                                      content: _vm.detailInfo.modifyReason,
                                      placement: "top-start",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        type: "textarea",
                                        autosize: { minRows: 2, maxRows: 4 },
                                        maxlength: "1000",
                                        "show-word-limit": "",
                                        placeholder: "请输入内容",
                                        disabled:
                                          _vm.isDisabled && _vm.isSet
                                            ? false
                                            : true,
                                      },
                                      model: {
                                        value: _vm.detailInfo.modifyReason,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.detailInfo,
                                            "modifyReason",
                                            $$v
                                          )
                                        },
                                        expression: "detailInfo.modifyReason",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _c("el-input", {
                                  attrs: {
                                    type: "textarea",
                                    autosize: { minRows: 2, maxRows: 4 },
                                    maxlength: "1000",
                                    "show-word-limit": "",
                                    placeholder: "请输入内容",
                                    disabled:
                                      _vm.isDisabled && _vm.isSet
                                        ? false
                                        : true,
                                  },
                                  model: {
                                    value: _vm.detailInfo.modifyReason,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailInfo,
                                        "modifyReason",
                                        $$v
                                      )
                                    },
                                    expression: "detailInfo.modifyReason",
                                  },
                                }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "handle-box", staticStyle: { "margin-top": "20px" } },
          [
            _vm._m(1),
            _c(
              "el-row",
              {
                staticStyle: { "margin-top": "10px" },
                attrs: { type: "flex", align: "middle" },
              },
              [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "acl",
                        rawName: "v-acl",
                        value: _vm.RMC_PROT_MEDICINE_UPLOAD,
                        expression: "RMC_PROT_MEDICINE_UPLOAD",
                      },
                    ],
                    attrs: {
                      disabled: _vm.isDisabled && _vm.isSet ? false : true,
                      size: "small",
                      type: "primary",
                    },
                    on: { click: _vm.openFile },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("common.selectFile")) + " ")]
                ),
              ],
              1
            ),
            _c(
              "el-table",
              {
                ref: "plxTable",
                staticStyle: { "margin-top": "10px" },
                attrs: {
                  data: _vm.fileList,
                  "max-height": "500",
                  "show-overflow": "ellipsis",
                  "highlight-current-row": "",
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    label: "文件名称",
                    prop: "documentName",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.onDownload(scope.row)
                                },
                              },
                            },
                            [_vm._v(_vm._s(scope.row.documentName))]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "附件描述",
                    align: "center",
                    prop: "docComments",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "dark",
                                content: scope.row.docComments,
                                placement: "top-start",
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "inline-block",
                                    maxHeight: "80px",
                                    padding: "10px 0px",
                                    "box-sizing": "border-box",
                                  },
                                },
                                [_vm._v(_vm._s(scope.row.docComments))]
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "上传人", align: "center", prop: "userName" },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "上传时间",
                    align: "center",
                    prop: "createDate",
                  },
                }),
                _vm.isDisabled && _vm.isSet
                  ? _c("el-table-column", {
                      attrs: {
                        label: "操作",
                        align: "center",
                        prop: "updateDate",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("i", {
                                  staticClass: "el-icon-delete",
                                  staticStyle: { color: "red" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.delFile(scope.row)
                                    },
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2759813660
                      ),
                    })
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            attrs: {
              title: "Facility列表",
              visible: _vm.dialogVisible,
              width: "85%",
              "before-close": _vm.handleClose,
            },
            on: {
              "update:visible": function ($event) {
                _vm.dialogVisible = $event
              },
            },
          },
          [
            _vm.dialogVisible
              ? _c("facilityList", { on: { selectData: _vm.selectData } })
              : _vm._e(),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            attrs: {
              title: "提示",
              visible: _vm.fileVisible,
              width: "30%",
              "before-close": _vm.closeFile,
            },
            on: {
              "update:visible": function ($event) {
                _vm.fileVisible = $event
              },
            },
          },
          [
            _vm.fileVisible
              ? _c("uploadFile", {
                  attrs: {
                    detailInfo: _vm.detailInfo,
                    tsReckindId: _vm.tsReckindId,
                  },
                  on: { close: _vm.closeFile },
                })
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "info_box_title",
        staticStyle: { "padding-left": "10px", "box-sizing": "border-box" },
      },
      [
        _c("p", { staticClass: "line" }),
        _c("p", { staticClass: "info_title" }, [_vm._v("药品清单")]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "info_box_title",
        staticStyle: { "padding-left": "10px", "box-sizing": "border-box" },
      },
      [
        _c("p", { staticClass: "line" }),
        _c("p", { staticClass: "info_title" }, [_vm._v("检测报告")]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }